<template>
    <BreadCrumb PageTitle="Liste des Conditionnement" />
    <ListeConditionnement />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ListeConditionnement from "../../components/Conditionnement/ListeConditionnement.vue";
  
  export default defineComponent({
    name: "ListeConditionnementPage",
    components: {
      BreadCrumb,
      ListeConditionnement,
    },
  });
  </script>